import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DealEffects } from './deal.effects';
import { reducer } from './deal.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('deal', reducer),
    EffectsModule.forFeature([DealEffects]),
  ],
  providers: [DealEffects],
})
export class DealStoreModule {}
